import { Actions } from "../constants/actionTypes";

const initialState = {};

export function createSiteReducer(state = initialState, action) {
  if (action.type === Actions.SET_CREATE_SITE_SELECTED_ORG) {
    return {
      ...state,
      createSiteSelectedOrg: action.data,
    };
  } else if (action.type === Actions.CREATE_SITE_FORM_REDIRECT) {
    return {
      ...state,
      redirect: action.data,
    };
  }

  return state;
}
